import { useEffect, useState, ReactElement } from "react";

import { Message } from "react-bulma-components";
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Color } from "react-bulma-components/src/modifiers";
/* eslint-enable */
import styled from "styled-components";

import { useGetSystemNotificationsApi } from "hooks/systemNotifications";

interface MessageElement {
  type: Color;
  title: ReactElement;
  body: ReactElement;
}

const NotificationBody = styled.span`
  white-space: pre-wrap;
`;
export const showNotificationBody = (comment: string): ReactElement => (
  <NotificationBody>{comment}</NotificationBody>
);

export function SystemNotification(): ReactElement | null {
  const [messages, setMessages] = useState<MessageElement[]>([]);
  const getNotifications = useGetSystemNotificationsApi();

  useEffect(() => {
    (async () => {
      const data = getNotifications.map(
        (item) =>
          ({
            type: item.type,
            title: <span>{item.title}</span>,
            body: showNotificationBody(item.body),
          } as MessageElement)
      );
      setMessages(data);
    })();
  }, [getNotifications]);

  return (
    <>
      {messages.map((message, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Message color={message.type} size="small" key={index}>
          <Message.Header>{message.title}</Message.Header>
          <Message.Body>{message.body}</Message.Body>
        </Message>
      ))}
    </>
  );
}
